/* ==========================================================================
   INDIGO BLUE RAY ANGEL — Custom JS
   Drop into: Online Store → Themes → Edit Code → Assets → ibra-theme.js
   Already linked in theme.liquid.
   ========================================================================== */

(function() {
  'use strict';

  // ---- Intersection Observer for scroll reveals ----
  function initReveals() {
    const elements = document.querySelectorAll('.ibra-reveal');
    if (!elements.length || !('IntersectionObserver' in window)) {
      elements.forEach(el => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });

    elements.forEach(el => observer.observe(el));
  }

  // ---- Newsletter popup (shows once per session after 8s) ----
  function initNewsletterPopup() {
    const popup = document.getElementById('ibra-newsletter-popup');
    if (!popup) return;
    if (sessionStorage.getItem('ibra-newsletter-seen')) return;

    setTimeout(() => {
      popup.classList.add('is-open');
      sessionStorage.setItem('ibra-newsletter-seen', '1');
    }, 8000);

    const closeBtn = popup.querySelector('.ibra-popup__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => popup.classList.remove('is-open'));
    }

    popup.addEventListener('click', (e) => {
      if (e.target === popup) popup.classList.remove('is-open');
    });
  }

  // ---- Find Your Crystal quiz ----
  function initCrystalQuiz() {
    const quiz = document.getElementById('ibra-quiz');
    if (!quiz) return;

    const steps = quiz.querySelectorAll('.ibra-quiz__step');
    const answers = {};
    let currentStep = 0;

    function showStep(idx) {
      steps.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      const progress = quiz.querySelector('.ibra-quiz__progress-fill');
      if (progress) progress.style.width = ((idx + 1) / steps.length * 100) + '%';
    }

    quiz.querySelectorAll('.ibra-quiz__option').forEach(opt => {
      opt.addEventListener('click', () => {
        const step = opt.closest('.ibra-quiz__step');
        const key = step.dataset.key;
        const value = opt.dataset.value;
        answers[key] = value;

        if (currentStep < steps.length - 1) {
          currentStep++;
          showStep(currentStep);
        } else {
          showResult();
        }
      });
    });

    function showResult() {
      const intention = answers.intention || 'love';
      const result = quiz.querySelector('.ibra-quiz__result');
      const link = result.querySelector('.ibra-quiz__result-link');

      // Map each quiz answer to its real collection handle.
      // Note: the "calm" button maps to the "calm-sleep" collection.
      const handleMap = {
        love:       'love',
        protection: 'protection',
        abundance:  'abundance',
        clarity:    'clarity',
        calm:       'calm-sleep'
      };
      if (link) {
        link.href = '/collections/' + (handleMap[intention] || intention);
      }

      const resultText = result.querySelector('.ibra-quiz__result-text');
      // Recommendations mapped to items actually in the catalogue, so the
      // link never lands on a collection missing the stone it promised.
      const recommendations = {
        love:       { crystal: 'Rose Quartz', desc: 'the stone of unconditional love and emotional healing.' },
        protection: { crystal: 'Cypriot Sage', desc: 'a sacred cleanser to clear and shield your space.' },
        abundance:  { crystal: 'Green Aventurine', desc: 'the stone of opportunity, luck, and quiet prosperity.' },
        clarity:    { crystal: 'Sodalite', desc: 'a stone of clear thought, focus, and calm insight.' },
        calm:       { crystal: 'Amethyst', desc: 'a soothing stone for sleep, peace, and intuition.' }
      };
      const rec = recommendations[intention] || recommendations.love;
      if (resultText) {
        resultText.innerHTML = '<strong>' + rec.crystal + '</strong> — ' + rec.desc;
      }
      steps.forEach(s => s.classList.remove('is-active'));
      result.classList.add('is-active');
    }

    const restart = quiz.querySelector('.ibra-quiz__restart');
    if (restart) {
      restart.addEventListener('click', () => {
        currentStep = 0;
        Object.keys(answers).forEach(k => delete answers[k]);
        quiz.querySelector('.ibra-quiz__result').classList.remove('is-active');
        showStep(0);
      });
    }

    showStep(0);
  }

  // ---- Testimonial carousel ----
  function initTestimonials() {
    const carousel = document.querySelector('.ibra-testimonials__track');
    if (!carousel) return;

    const slides = carousel.querySelectorAll('.ibra-testimonial');
    const dots = document.querySelectorAll('.ibra-testimonials__dot');
    let current = 0;

    function goTo(idx) {
      current = idx;
      carousel.style.transform = 'translateX(-' + (idx * 100) + '%)';
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    }

    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

    setInterval(() => {
      goTo((current + 1) % slides.length);
    }, 6000);
  }

  // ---- Init on DOM ready ----
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initReveals();
    initNewsletterPopup();
    initCrystalQuiz();
    initTestimonials();
  }
})();

/* ============================================================
   IBRA — Hero slideshow auto-cycle
   ============================================================ */
(function () {
  function initIbraHero() {
    const heroSection = document.querySelector('.ibra-hero');
    if (!heroSection) return;
    if (heroSection.dataset.ibraHeroInit === 'true') return;
    heroSection.dataset.ibraHeroInit = 'true';

    const slideshow = heroSection.querySelector('[data-ibra-hero-slideshow]');
    if (!slideshow) return;

    const slides = slideshow.querySelectorAll('.ibra-hero__slide');
    if (slides.length < 2) return;

    const interval = parseInt(heroSection.dataset.cycleInterval || '3000', 10);
    const pauseOnHover = heroSection.dataset.pauseOnHover === 'true';
    const cycleBtn = heroSection.querySelector('[data-ibra-cycle-btn]');

    let current = 0;
    let timer;

    function applySlide(idx) {
      slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));

      if (!cycleBtn) return;
      const slide = slides[idx];
      const text = slide.dataset.btnText || cycleBtn.dataset.defaultText || '';
      const link = slide.dataset.btnLink || cycleBtn.dataset.defaultLink || '#';

      cycleBtn.style.opacity = '0';
      setTimeout(() => {
        if (text) cycleBtn.textContent = text;
        if (link) cycleBtn.setAttribute('href', link);
        cycleBtn.style.opacity = '1';
      }, 300);
    }

    function next() {
      current = (current + 1) % slides.length;
      applySlide(current);
    }

    function start() {
      stop();
      timer = setInterval(next, interval);
    }

    function stop() {
      if (timer) clearInterval(timer);
    }

    if (pauseOnHover) {
      heroSection.addEventListener('mouseenter', stop);
      heroSection.addEventListener('mouseleave', start);
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    applySlide(0);
    start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIbraHero);
  } else {
    initIbraHero();
  }

  document.addEventListener('shopify:section:load', initIbraHero);
})();

/* ============================================================
   IBRA — Auto-scrolling carousels (Categories + Featured)
   Continuous gentle scroll. Pauses on hover / touch / wheel /
   focus. Resumes after 10 seconds of no interaction.
   ============================================================ */
(function () {
  const RESUME_DELAY = 10000; // 10 seconds
  const SCROLL_SPEED = 0.6;   // pixels per frame (~36px/sec)

  function initIbraAutoCarousels() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const selectors = [
      '.ibra-categories .ibra-categories__grid',
      '.ibra-featured .ibra-featured__grid'
    ];
    const tracks = document.querySelectorAll(selectors.join(','));

    tracks.forEach((track) => {
      if (track.dataset.ibraAuto === 'true') return;
      track.dataset.ibraAuto = 'true';
      track.classList.add('is-carousel');

      // Let layout settle, then check if overflow exists
      requestAnimationFrame(() => {
        if (track.scrollWidth <= track.clientWidth + 5) return;

        // Clone all originals once for seamless looping
        const originals = Array.from(track.children);
        originals.forEach((child) => {
          const clone = child.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.classList.add('ibra-clone');
          clone.classList.remove('ibra-reveal');
          clone.querySelectorAll('.ibra-reveal').forEach((el) => {
            el.classList.remove('ibra-reveal');
          });
          track.appendChild(clone);
        });

        let paused = false;
        let resumeTimer = null;

        function getLoopPoint() {
          const firstClone = track.children[originals.length];
          return firstClone ? firstClone.offsetLeft : 0;
        }

        function step() {
          if (!paused) {
            track.scrollLeft += SCROLL_SPEED;
            const loopPoint = getLoopPoint();
            if (loopPoint && track.scrollLeft >= loopPoint) {
              track.scrollLeft -= loopPoint;
            }
          }
          requestAnimationFrame(step);
        }

        function pause() {
          paused = true;
          if (resumeTimer) {
            clearTimeout(resumeTimer);
            resumeTimer = null;
          }
        }

        function scheduleResume() {
          if (resumeTimer) clearTimeout(resumeTimer);
          resumeTimer = setTimeout(() => {
            paused = false;
            resumeTimer = null;
          }, RESUME_DELAY);
        }

        function pauseAndSchedule() {
          pause();
          scheduleResume();
        }

        // Desktop hover
        track.addEventListener('mouseenter', pause);
        track.addEventListener('mouseleave', scheduleResume);

        // Mobile touch
        track.addEventListener('touchstart', pause, { passive: true });
        track.addEventListener('touchend', scheduleResume, { passive: true });
        track.addEventListener('touchcancel', scheduleResume, { passive: true });

        // Trackpad / scroll wheel
        track.addEventListener('wheel', pauseAndSchedule, { passive: true });

        // Keyboard focus (a11y)
        track.addEventListener('focusin', pause);
        track.addEventListener('focusout', scheduleResume);

        // Pause when tab is hidden
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            paused = true;
          } else {
            scheduleResume();
          }
        });

        step();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIbraAutoCarousels);
  } else {
    initIbraAutoCarousels();
  }

  document.addEventListener('shopify:section:load', initIbraAutoCarousels);
})();

/* ============================================================
   IBRA — Hover overlay injection on collection cards
   Reads descriptions from #ibra-descriptions-data, then
   inserts an overlay into each card's gallery container.
   ============================================================ */
(function () {
  function initIbraOverlays() {
    const dataEl = document.getElementById('ibra-descriptions-data');
    let descriptions = {};
    if (dataEl) {
      try {
        descriptions = JSON.parse(dataEl.textContent.trim());
      } catch (e) {
        descriptions = {};
      }
    }

    const cards = document.querySelectorAll('product-card[data-product-id]');
    if (!cards.length) return;

    cards.forEach((card) => {
      if (card.dataset.ibraOverlay === 'true') return;
      card.dataset.ibraOverlay = 'true';

      // Get the product handle from the card's link
      const link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      const href = link.getAttribute('href');
      const handleMatch = href.match(/\/products\/([^/?#]+)/);
      if (!handleMatch) return;
      const handle = handleMatch[1];

      // Get the title — fall back to a derived one if the card lacks one
      let titleEl = card.querySelector('.product-title, .card__heading, h3, h2');
      let title = titleEl ? titleEl.textContent.trim() : '';
      if (!title) {
        title = handle.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
      }

      // Get description — fall back to empty (we'll hide the <p> if so)
      const description = (descriptions[handle] || '').trim();

      // Find the gallery container
      const gallery =
        card.querySelector('.card-gallery') ||
        card.querySelector('[class*="card-gallery"]') ||
        card.querySelector('.product-card__media') ||
        card.querySelector('img')?.closest('div');

      if (!gallery) return;

      // Build the overlay
      const overlay = document.createElement('div');
      overlay.className = 'ibra-hover';
      overlay.setAttribute('aria-hidden', 'true');

      const parts = [];
      parts.push('<div class="ibra-hover__frame"></div>');
      parts.push('<span class="ibra-hover__eyebrow">Discover</span>');
      parts.push('<h3 class="ibra-hover__title">' + title + '</h3>');
      parts.push('<span class="ibra-hover__divider"></span>');
      if (description) {
        parts.push('<p class="ibra-hover__text">' + description + '</p>');
      }
      parts.push(
        '<a href="' + href + '" class="ibra-hover__cta">' +
          'View piece <span class="arrow">→</span>' +
        '</a>'
      );

      overlay.innerHTML = parts.join('');
      gallery.appendChild(overlay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIbraOverlays);
  } else {
    initIbraOverlays();
  }

  document.addEventListener('shopify:section:load', initIbraOverlays);

  // Catch cards added by infinite scroll
  const observer = new MutationObserver(() => initIbraOverlays());
  observer.observe(document.body, { childList: true, subtree: true });
})();